export const hasRecordId = (id) =>
  (typeof id === "number" && Number.isFinite(id) && id > 0) ||
  (typeof id === "string" && id.trim() !== "" && !["0", "null", "undefined"].includes(id.trim()));
